import React from "react"

interface CarouselProps {
	items: React.ReactNode[]
}

function Carousel({ items }: CarouselProps) {
	const [current, setCurrent] = React.useState(0)

	const handleNext = (e: React.MouseEvent) => {
		e.preventDefault()
		setCurrent(prev => (prev === items.length - 1 ? 0 : prev + 1))
	}

	const handlePrev = (e: React.MouseEvent) => {
		e.preventDefault()
		setCurrent(prev => (prev === 0 ? items.length - 1 : prev - 1))
	}

	return (
		<div className="relative w-full h-full flex justify-center items-center bg-surface-tertiary">
			{items.map((item, index) => (
				<div 
					key={index} 
					className={index === current ? "block" : "hidden"}
				>
					{item}
				</div>
			))}
			{items.length > 1 && (
				<>
					<button 
						onClick={handlePrev} 
						className="absolute left-0 top-1/2 -translate-y-1/2 z-10 cursor-pointer border-none bg-black/60 text-white shadow-md rounded-arc-md px-2 py-1 hover:bg-black/80 transition-colors"
					>
						{"<"}
					</button>

					<button 
						onClick={handleNext} 
						className="absolute right-0 top-1/2 -translate-y-1/2 z-10 cursor-pointer border-none bg-black/60 text-white shadow-md rounded-arc-md px-2 py-1 hover:bg-black/80 transition-colors"
					>
						{">"}
					</button>
				</>
			)}

			{items.length > 1 && (
				<div className="absolute bottom-0 right-0 p-1.5 bg-black/60 text-white rounded-arc-md text-xs">
					{current + 1} / {items.length}
				</div>
			)}
		</div>
	)
}

export default Carousel
